import React from 'react';
import { LABEL_COLORS } from '../../constants/labelColors';
import { ColorPicker as StyledColorPicker, ColorOption } from '../../styles/LabelPicker.styles';

const ColorPicker = ({ selectedColor, onColorSelect }) => (
    <StyledColorPicker>
        {Object.entries(LABEL_COLORS).map(([color, name]) => (
            <ColorOption
                key={color}
                color={color}
                selected={selectedColor === color}
                onClick={() => onColorSelect(color)}
                title={name}
            />
        ))}
    </StyledColorPicker>
);

export default ColorPicker;